import {
  AfterViewInit,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { AbcComponentService } from '../abcComponent.service';

@Component({
  selector: 'tile',
  template: `
    <ng-template>
      <div class="pointer-arrow-right">
        <button
          #button
          mat-button
          (click)="this.click.emit()"
          class="tileStyle"
          [disabled]="disabled"
          [matTooltip]="tooltip"
          [disableRipple]="disableRipple"
        >
          <ng-content></ng-content>
        </button>
      </div>
    </ng-template>
  `,
  styles: [
    `
      .tileStyle {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    `,
  ],
  standalone: false,
})
export class AbcTileComponent implements AfterViewInit, OnDestroy {
  @Input() customClass: string;
  @Input() tooltip: string | null = null;
  @Input() disabled: boolean = false;
  @Input() disableRipple: boolean = false;
  @Output() click = new EventEmitter<string>();
  @ViewChild(TemplateRef, { static: true }) template: TemplateRef<any>;
  @ViewChild('button', { static: true }) buttonElement: any; //the "current static" button
  @ViewChildren('button') buttons: QueryList<any>; //for "dynamic" buttons
  private subscription: Subscription[] = [];

  ngAfterViewInit() {
    if (this.customClass) {
      if (this.buttonElement) {
        this.buttonElement._elementRef.nativeElement.classList.add(this.customClass);
      }
      this.subscription.push(
        this.buttons.changes.subscribe((val) => {
          for (const button of this.buttons.toArray()) {
            button._elementRef.nativeElement.classList.add(this.customClass);
          }
        }),
      );
    }
  }

  ngOnDestroy(): void {
    this.subscription.forEach((element) => {
      element.unsubscribe();
    });
  }
}
@Component({
  selector: 'abctilemenu',
  template: `
    <ng-template let-buttonStyle="buttonStyle">
      <button #button mat-button (click)="this.click.emit()" [class]="buttonStyle">
        <ng-content></ng-content>
      </button>
    </ng-template>
  `,
  standalone: false,
})
export class AbcTileMenuComponent {
  @Input() menuData;
  @Output() click = new EventEmitter<number>();
  @ViewChild(TemplateRef, { static: true }) template: TemplateRef<any>;

  public trackByIndex(index) {
    return index;
  }
}
@Component({
  selector: 'abcTileNavMenu',
  template: `
    <div #rootDiv class="tilenavcontainer" [dir]="rtlEnabled" [ngClass]="{ small: size == 'small' }">
      @for (tile of tiles; track tile; let i = $index) {
        <ng-container *ngTemplateOutlet="tile.template"></ng-container>
        @if (i < tiles.length - 1) {
          <mat-icon
            [ngClass]="rtlEnabled === 'rtl' ? 'tilenavdelimiterRtl' : 'tilenavdelimiter'"
            svgIcon="tileNavRight"
          ></mat-icon>
        }
      }
      @if (menus.length > 0) {
        <mat-icon class="tilenavdelimiter" svgIcon="tileNavRight"></mat-icon>
        <button mat-button [matMenuTriggerFor]="menu" class="menuTrigger" (click)="changeStyleProperty()">
          <mat-icon class="more-info" svgIcon="moreInfo"></mat-icon>
        </button>
        <mat-menu #menu="matMenu" yPosition="above">
          @for (menu of menus; track menu; let i = $index) {
            @if (i + 1 < menus.length) {
              <div><ng-container *ngTemplateOutlet="menu.template"></ng-container></div>
            }
          }
        </mat-menu>
      }

      @for (menu of menus; track menu; let i = $index) {
        @if (i + 1 == menus.length) {
          <mat-icon class="tilenavdelimiter" svgIcon="tileNavRight"></mat-icon>
          <ng-container *ngTemplateOutlet="menu.template; context: { buttonStyle: 'tileStyle' }"></ng-container>
        }
      }
    </div>
  `,
  styles: [
    `
      .tilenavcontainer {
        display: flex;
        align-items: center;
      }
      .tilenavdelimiter {
        transform: scale(0.7);
      }

      .tilenavdelimiterRtl {
        transform: scale(0.7) rotate(180deg);
      }
      .menuTrigger {
        color: #443161;
        background: white;
        border-radius: 0 !important;
        min-width: 0 !important;
        padding: 0 !important;
        width: 24px;
      }

      .menuTrigger .mat-icon {
        width: 100% !important;
      }

      ::ng-deep .small .mat-button-wrapper {
        font-size: var(--abcTileNavMenuFontSize, 12px) !important;
      }
    `,
  ],
  standalone: false,
})
export class AbcTileNavMenuComponent implements OnInit {
  @Input() customClass: string;
  @Input() rtlEnabled;
  @Input() size: 'small' | 'normal' = 'normal';
  @ContentChildren(AbcTileComponent) tiles: QueryList<AbcTileComponent>;
  @ContentChildren(AbcTileMenuComponent) menus: QueryList<AbcTileMenuComponent>;
  @ViewChild('rootDiv', { static: true }) rootDiv: ElementRef<HTMLDivElement>;
  constructor(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private abcComponentService: AbcComponentService,
  ) {
    iconRegistry.addSvgIcon('tileNavRight', sanitizer.bypassSecurityTrustResourceUrl('assets/images/tileNavRight.svg'));
    iconRegistry.addSvgIcon('moreInfo', sanitizer.bypassSecurityTrustResourceUrl('assets/images/more_info.svg'));
    this.rtlEnabled = this.abcComponentService.rtlEnabled ? 'rtl' : 'ltr';
  }

  ngOnInit() {
    if (this.customClass) {
      this.rootDiv.nativeElement.classList.add(this.customClass);
    }
  }

  changeStyleProperty() {
    const element = document.querySelector('.cdk-overlay-container') as HTMLElement;
    element.style.setProperty('--index-value', '1503');
  }
}
